function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a21942;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Artboard 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "_Group_",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("rect", {
  id: "_Path_",
  "data-name": "<Path>",
  className: "cls-1",
  y: -0.02,
  width: 1000,
  height: 1000.03
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M194.3,236.09v-22c0-19.32-6.83-33.3-22.6-40.44,13.37-6.53,19.63-18.43,19.63-35.08v-8.34c0-31.52-16.35-48.47-47.58-48.47-30.92,0-47,17-47,48.47v8.34c0,16.36,6,28.55,19,35.08-15.76,7.14-22.31,21.12-22.31,40.44v22c0,30.62,14.58,52,50.27,52,36,0,50.55-21.42,50.55-52m-65.73-108c0-12.21,4.18-19.34,15.18-19.34,11.29,0,15.46,7.13,15.46,19.34v13.67c0,12.19-4.17,19.35-15.46,19.35-11,0-15.18-7.16-15.18-19.35ZM160.4,239.65c0,12.2-4.46,20.82-16.65,20.82-11.9,0-16.36-8.62-16.36-20.82V206.94c0-12.19,4.46-20.82,16.36-20.82,12.19,0,16.65,8.63,16.65,20.82Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "_Path_2",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M694.16,492,592.52,588.67c-3.83,3.81-5.8,6.62-5.8,14.52v271a5.8,5.8,0,0,0,5.8,5.78h105a5.79,5.79,0,0,0,5.79-5.78V494.42c0-3.2-2.5-9-9.14-2.44"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_3",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M401.34,618,299.69,714.63c-3.82,3.82-5.8,6.62-5.8,14.51v145a5.8,5.8,0,0,0,5.8,5.77h105a5.79,5.79,0,0,0,5.79-5.77V620.38c0-3.21-2.53-9.06-9.14-2.43"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_4",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M740.36,374.72a2.84,2.84,0,0,0-.86-2.2,3.06,3.06,0,0,0-1.88-.83l-.56,0-.83,0L658.4,389.33l-1.41.15a3.14,3.14,0,0,0-1.52.79,3,3,0,0,0,0,4.19l.88.88,17.78,17.77L497.77,589.47,416.32,508a2.32,2.32,0,0,0-3.32,0l-22.1,22.11a0,0,0,0,0,0,0L260.31,660.69a2.38,2.38,0,0,0,0,3.32l22.13,22.12a2.32,2.32,0,0,0,3.29,0l129-128.92,59.1,59.12a2.31,2.31,0,0,0,.19.28l22.11,22.08a2.31,2.31,0,0,0,3.31,0L699.55,438.54l18.66,18.65a2.91,2.91,0,0,0,4.15,0,2.8,2.8,0,0,0,.85-1.92l0-.24,17.09-79.45Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Path_5",
  "data-name": "<Path>",
  className: "cls-2",
  d: "M548.33,634.92,499.15,684.5a2.35,2.35,0,0,1-3.17-.12L451.43,639c-8.16-8.12-9.92-1.53-9.92,1.66V874.17a5.77,5.77,0,0,0,5.76,5.78h105a5.79,5.79,0,0,0,5.77-5.78V636.75c0-3.19-2.51-9.06-9.73-1.83"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Group_2",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_2",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M309.8,105.61v37.85c0,12.54-5.19,21.94-19.89,21.94H268.69V83.67h21.22C304.61,83.67,309.8,93,309.8,105.61Zm-21.58,48.58c5.67,0,7.84-3.37,7.84-8.32V103.08c0-4.83-2.17-8.2-7.84-8.2h-5.79v59.31Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_3",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M318.48,83.67h32.79V94.88h-19v23.39h13.62v11.09H332.22v24.83h19V165.4H318.48Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_4",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M358.26,144.31V104.76c0-12.78,6-22.06,20.49-22.06,15.19,0,19.41,8.44,19.41,20.5v9.64H385.63V102.11c0-5.06-1.69-8-6.63-8s-7,3.5-7,8.44v43.89c0,4.94,2.05,8.44,7,8.44s6.63-3.14,6.63-8V131.89h12.53V146c0,11.7-4.82,20.38-19.41,20.38S358.26,157,358.26,144.31Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_5",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M406.48,83.67h32.79V94.88h-19v23.39h13.63v11.09H420.22v24.83h19V165.4H406.48Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_6",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M459,114.05V165.4H447.47V83.67H461l14.83,46.89V83.67h11.45V165.4H475.2Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_7",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M494.36,83.67h36.53V94.88H519.56V165.4H505.69V94.88H494.36Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_8",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M581.28,114.89l-7.71,50.51h-12.9l-11-81.73H563l6.39,51.84h.12l6.87-51.84h11.21l7.59,51.84h.12l6.27-51.84h11.58L602.5,165.4h-13l-8.08-50.51Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_9",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M618.65,144.31V104.76c0-12.78,6.27-22.06,20.74-22.06s20.85,9.28,20.85,22.06v39.55c0,12.66-6.27,22.06-20.85,22.06S618.65,157,618.65,144.31Zm27.85,2.17V102.59c0-4.94-2.17-8.44-7.11-8.44s-7,3.5-7,8.44v43.89c0,4.94,2.17,8.44,7,8.44S646.5,151.42,646.5,146.48Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_10",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M682.66,127.91V165.4H668.92V83.67h20c13.87,0,18.93,6.87,18.93,18.32v10.49c0,8.8-3.13,14-11,15.79L710,165.4H695.56Zm0-33v25.44h4.58c4.71,0,6.76-2.42,6.76-6.76v-12c0-4.46-2-6.63-6.76-6.63Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_11",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M729.92,125.62V165.4H716.18V83.67h13.74v35.92l15-35.92h13.5l-15.91,36.77,16.27,45H744.27Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_12",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M777.9,165.4l15.43-81.73H809l15.56,81.73H810.45l-2.53-14.94H793.33l-2.41,14.94Zm17.24-25.92h11l-5.42-32.79h-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_13",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M840.71,114.05V165.4H829.13V83.67h13.51l14.83,46.89V83.67h11.45V165.4H856.86Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_14",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M919.07,105.61v37.85c0,12.54-5.19,21.94-19.9,21.94H878V83.67h21.21C913.88,83.67,919.07,93,919.07,105.61Zm-21.58,48.58c5.66,0,7.83-3.37,7.83-8.32V103.08c0-4.83-2.17-8.2-7.83-8.2H891.7v59.31Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "_Group_3",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_15",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M268.69,203.71h32.79v11.21H282.43v23.39h13.63V249.4H282.43v24.84h19.05v11.21H268.69Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_16",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M307.51,264.35V224.81c0-12.78,6-22.06,20.49-22.06,15.19,0,19.41,8.43,19.41,20.49v9.65H334.87V222.16c0-5.07-1.68-8-6.63-8s-7,3.49-7,8.44v43.88c0,4.94,2.05,8.44,7,8.44s6.63-3.13,6.63-8V251.93h12.54V266c0,11.69-4.82,20.37-19.41,20.37S307.51,277,307.51,264.35Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_17",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M354.88,264.35V224.81c0-12.78,6.27-22.06,20.74-22.06s20.86,9.28,20.86,22.06v39.54c0,12.66-6.27,22.06-20.86,22.06S354.88,277,354.88,264.35Zm27.85,2.17V222.64c0-4.95-2.17-8.44-7.11-8.44s-7,3.49-7,8.44v43.88c0,4.94,2.17,8.44,7,8.44S382.73,271.46,382.73,266.52Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_18",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M415.88,234.09v51.36H404.31V203.71h13.5l14.83,46.9v-46.9h11.45v81.74H432Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_19",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M451.93,264.35V224.81c0-12.78,6.27-22.06,20.73-22.06s20.86,9.28,20.86,22.06v39.54c0,12.66-6.27,22.06-20.86,22.06S451.93,277,451.93,264.35Zm27.85,2.17V222.64c0-4.95-2.17-8.44-7.12-8.44s-7,3.49-7,8.44v43.88c0,4.94,2.17,8.44,7,8.44S479.78,271.46,479.78,266.52Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_20",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M539.21,232.4h-.36l-9.29,53h-6.39l-10.24-53h-.25v53H501.35V203.71h16l8.92,46h.12l8-46h17.37v81.74H539.21Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_21",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M559.58,203.71h13.74v81.74H559.58Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_22",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M581,264.35V224.81c0-12.78,6-22.06,20.49-22.06,15.19,0,19.41,8.43,19.41,20.49v9.65H608.4V222.16c0-5.07-1.69-8-6.63-8s-7,3.49-7,8.44v43.88c0,4.94,2.05,8.44,7,8.44s6.63-3.13,6.63-8V251.93h12.54V266c0,11.69-4.82,20.37-19.41,20.37S581,277,581,264.35Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_23",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M665.06,241.81h19.53v43.64h-9.88v-8.92c-1.81,6.15-5.67,9.88-13.14,9.88-11.82,0-17.24-9.4-17.24-22.06V224.81c0-12.78,6.14-22.06,20.61-22.06,15.19,0,19.65,8.43,19.65,20.49v7.23H672.05v-8.31c0-5.07-1.93-8-6.87-8s-7.11,3.49-7.11,8.44v43.88c0,4.94,2,8.44,6.75,8.44,4.46,0,6.75-2.53,6.75-7.84V252.66h-6.51Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_24",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M706.17,248v37.49H692.42V203.71h20c13.86,0,18.93,6.87,18.93,18.32v10.49c0,8.8-3.14,14-11,15.8l13.15,37.13H719.07Zm0-33v25.44h4.58c4.7,0,6.75-2.41,6.75-6.75V221.55c0-4.46-2-6.63-6.75-6.63Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_25",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M737.63,264.35V224.81c0-12.78,6.27-22.06,20.74-22.06s20.85,9.28,20.85,22.06v39.54c0,12.66-6.26,22.06-20.85,22.06S737.63,277,737.63,264.35Zm27.85,2.17V222.64c0-4.95-2.17-8.44-7.11-8.44s-7,3.49-7,8.44v43.88c0,4.94,2.17,8.44,7,8.44S765.48,271.46,765.48,266.52Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_26",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M814.42,234.93l-7.71,50.52h-12.9l-11-81.74H796.1l6.39,51.84h.12l6.87-51.84h11.21l7.6,51.84h.12l6.27-51.84h11.57l-10.61,81.74h-13l-8.08-50.52Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_27",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M850.47,203.71H887v11.21H875.67v70.53H861.8V214.92H850.47Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_Compound_Path_28",
  "data-name": "<Compound Path>",
  className: "cls-2",
  d: "M918.22,249.4H905v36H891.21V203.71H905v34.6h13.26v-34.6h13.86v81.74H918.22Z"
})));

var SvgColorGoal08 = function SvgColorGoal08(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorGoal08, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Color_Goal_08.f82f7cc7.svg";
export { ForwardRef as ReactComponent };